import { REACT_APP_PUBLIC_URL } from "../common/config";

export const getUrlFromConfig = (path = "") => {
  return `${REACT_APP_PUBLIC_URL}${path}`;
};
